import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import config from '@plone/volto/registry';

import { buildSearchUrl } from '../../../../helpers/search';
import { getActiveLanguage } from '../../../../helpers/homepageUrl';

const messages = defineMessages({
  tagsLabel: {
    id: 'Tags label',
    defaultMessage: 'Etiquetes:',
  },
});

const Tags = ({ content }) => {
  const intl = useIntl();
  const location = useLocation();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(location.pathname, locale);
  const tags = content?.subjects || [];

  if (!config.settings.showTags || !tags.length) {
    return null;
  }

  return (
    <Container className="csj-tags">
      <span>{intl.formatMessage(messages.tagsLabel)} </span>
      {tags.map((tag) => (
        <Link
          className="ui label"
          to={buildSearchUrl(language, { Subject: tag })}
          key={tag}
        >
          {tag}
        </Link>
      ))}
    </Container>
  );
};

Tags.propTypes = {
  content: PropTypes.shape({
    subjects: PropTypes.arrayOf(PropTypes.string),
  }),
};

Tags.defaultProps = {
  content: {
    subjects: [],
  },
};

export default Tags;
